import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/custom/css/add.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Recents = () => {
  const [recentList, setRecentList] = useState([]);

  useEffect(() => {
    const dummyData = Array.from({ length: 5 }).map((_, i) => ({
      id: i + 1,
      mobile_number: `98765432${i}${i}`,
      agentId: { username: `Agent ${i + 1}` },
      remark: [`Recent call ${i + 1}`],
      created_at: new Date(Date.now() - i * 12 * 60000),
    }));

    const formatted = dummyData.map((item) => ({
      ...item,
      createdAtFormatted: new Date(item.created_at).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    }));

    setRecentList(formatted);
  }, []);

  const phoneTimeTemplate = (rowData) => (
    <div className="remark-item" style={{ display: "flex", alignItems: "center" }}>
      <div
        className="remark-avatar"
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: "#ffffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "8px",
          border: "2px solid green",
        }}
      >
        <i className="fa fa-phone" style={{ rotate: "90deg", fontSize: "12px", color: "green" }} />
      </div>
      <div className="remark-info" style={{ flexGrow: 1 }}>
        <div className="remark-phone" style={{ fontWeight: "bold" }}>
          {rowData.mobile_number}
        </div>
        <div className="remark-time" style={{ fontSize: "12px", color: "#666" }}>
          {rowData.createdAtFormatted}
        </div>
      </div>
    </div>
  );

  return (
    <div className="card" style={{ height: "480px", overflow: "hidden" }}>
      <div className="card-body" style={{ padding: "0.10rem" }}>
        <div style={{ maxHeight: "480px", overflowY: "auto" }}>
          <DataTable value={recentList} rows={5} className="p-datatable-sm">
            <Column header="Contact Info" body={phoneTimeTemplate} style={{ width: "5%", padding: "4px" }} />
            <Column
              field="agentId.username"
              header="Agent Name"
              style={{ width: "20%", padding: "4px" }}
              headerStyle={{ textAlign: "left", paddingLeft: "-11px" }}
            />
            <Column
              header="Remarks"
              body={() => (
                <i className="fa fa-eye" style={{ cursor: "default", color: "#6c757d" }} />
              )}
              style={{ width: "10%", textAlign: "center" }}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default Recents;


